import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"2"},
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1 13v10h17l5-5-5-5zM5 13V8M15 13V1",
      style: {"fill":"none","stroke":"currentColor","stroke-width":"2px"}
    }, null, -1),
    _createElementVNode("path", {
      d: "m9 13 4 5-4 5",
      style: {"fill":"none","stroke":"currentColor","stroke-width":"2px"}
    }, null, -1),
    _createElementVNode("circle", {
      cx: "5",
      cy: "6",
      r: "2",
      style: {"fill":"none","stroke":"currentColor","stroke-width":"2px"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M15 1h8l-1 3 1 3h-8",
      style: {"fill":"none","stroke":"currentColor","stroke-width":"2px"}
    }, null, -1)
  ]))]))
}
export default { render: render }